<!--
 * @Autor: yingna.gao
 * @Date: 2022-07-07 11:23:48
 * @LastEditTime: 2022-07-11 17:20:00
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /scim-edm-web/src/views/standard/home/components/workbench-config.vue
-->
<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    title="工作台"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="90vw"
    append-to-body
  >
    <div class="workbench-config-wrap">
      <div v-show="checkedMenu.length" class="checked-menu">
        <workbench-item  ref="workbenchItem" :item-list="checkedMenu" :show-delete="true" :draggabled="false" @delCheckedMenu="delCheckedMenu"/>
      </div>
      <div class="menu-list-wrap">
        <workbench-item  :item-list="menuList" :is-edit="true" @getChekedMenu="getChekedMenu"/>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button type="primary" :loading="saveLoading" @click="handleConfirm">
        {{ $t("public.save") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import WorkbenchItem from "./workbench-item";
import cockpitApi from "@/api/cockpit/cockpit";
export default {
  name: "WorkbenchConfig",
  components: {
    WorkbenchItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      saveLoading: false,
      menuList: [],
      checkedMenu: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  async created() {
    await this.getMenuByRoleList();
    this.getWorkbenchList();
  },
  methods: {
    getChekedMenu(item) {
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].id === item.id) {
          item.checked = !item.checked;
          this.menuList.splice(i, 1, item);
          break;
        }
      }
      this.checkedMenu = this.menuList.filter(menu => menu.checked);
    },
    getMenuByRoleList() {
      // 先查询后台并返回左侧菜单数据并把数据添加到路由
      const parmas = {
        keys: this.$store.getters.roles
      };
      return cockpitApi.getMenuByRoleId().then(res => {
        // console.log(res);
        if (res.success && res.data) {
          const menuTree = res.data || [];
          this.menuList = this.getMenuList(menuTree);
        }
      });
    },
    getWorkbenchList() {
      cockpitApi.getHomeConfig({}).then(res => {
        if (res.success && res.data) {
          const extendedData = res.data.extendedData || {};
          extendedData.workbenchList.forEach(bench => {
            bench.checked = true;
          });
          this.menuList.forEach(menu => {
            const includs = extendedData.workbenchList.some(bench => bench.id === menu.id);
            if (includs) {
              this.$set(menu, "checked", true);
            } else {
              this.$set(menu, "checked", false);
            }
          });
          this.$store.commit("user/SET_LAYOUT_CONFIG_EXTENED_DATA", extendedData);
          this.checkedMenu = extendedData.workbenchList || [];
        }
      });
    },
    getMenuList(menuTree) {
      const menuList = [];
      menuTree.forEach(menu => {
        if (menu.clientType === "WEB" && menu.menuType === "MENU" && menu.menuPath) {
          menuList.push(menu);
        }
        if (menu.children && menu.children.length) {
          const childMenu = this.getMenuList(menu.children);
          menuList.push(...childMenu);
        }
      });
      return menuList;
    },
    // 确认提交
    handleConfirm() {
      const parmas = {
        extendedData: {
        }
      };
      this.saveLoading = true;
      const checkedMenu = this.$refs.workbenchItem && this.$refs.workbenchItem.menuList;
      const { layoutConfigExtendData } = this.$store.state.user;
      Object.assign(parmas.extendedData, layoutConfigExtendData, { workbenchList: checkedMenu });
      cockpitApi.homeConfigSave(parmas).then(res => {
        this.saveLoading = false;
        if (res.success) {
          this.$message.success(this.$t("maintenanceStrategy.saveSuccess"));
          this.dialogVisible = false;
          const extendedData = res.data.extendedData || {};
          this.$store.commit("user/SET_LAYOUT_CONFIG_EXTENED_DATA", extendedData);
          this.$emit("refresh", true);
        }
      }, () => {
        this.saveLoading = false;
      });
    },
    delCheckedMenu(index, item) {
      this.checkedMenu.splice(index, 1);
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].id === item.id) {
          item.checked = false;
          this.menuList.splice(i, 1, item);
          return;
        }
      }
    }
  }
};
</script>

<style>
.workbench-config-wrap{
    height:100%;
    display:flex;
    flex-direction: column;
}
.checked-menu{
    max-height:240px;
    overflow-y:auto;
    padding:8px 0 4px;
    border-bottom:1px solid #EBECEF;
    margin-bottom:16px;
}
.menu-list-wrap{
    flex:1;
    overflow-y:auto;
    padding:8px 0 16px;
}
</style>
